import type { Prices } from "../api/models";
import { money } from "../lib/format";

/** "raw $3.20 · PSA 9 $12.00 · PSA 10 $40.00", or nothing when the catalog had no prices. */
export function PriceLine({ prices }: { prices: Prices | undefined }) {
  if (!prices) return null;
  const parts = [
    prices.raw != null ? `raw ${money(prices.raw)}` : null,
    prices.psa9 != null ? `PSA 9 ${money(prices.psa9)}` : null,
    prices.psa10 != null ? `PSA 10 ${money(prices.psa10)}` : null,
  ].filter(Boolean);
  if (parts.length === 0) return null;
  return <span className="mono muted nowrap">{parts.join(" · ")}</span>;
}
